import ServiceFactory from "utilities/services/service-factory";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------
class DownloadPath {}
export interface PermalinksBasePathParams {
    publicationId: number;
}

// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "publications/:publicationId/permalinks";

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------

const PermalinksService = {
    get: ServiceFactory.get<DownloadPath, PermalinksBasePathParams, {}>(
        DownloadPath,
        baseEndpoint
    ),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default PermalinksService;

// #endregion Exports
